import { ReactNode } from 'react';
import { IntegrationConfigAppModelV2 } from '@api';
import { FormSection } from '@Integrations/IntegrationConfigForm/components/FormSection/FormSection';
import { FormSectionSummary } from '@Integrations/IntegrationConfigForm/components/FormSection/FormSectionSummary';
import { Stack } from '@mui/material';
import { CustomAccessDetailsField } from '@Integrations/organisms/IntegrationConfigForm/ConfigForm/CustomAccessDetails/CustomAccessDetailsField';

export function CustomAccessDetailsFormSection({
  config,
  actions,
  expanded,
  isEdit,
  onSummaryClick,
}: {
  config: IntegrationConfigAppModelV2;
  actions?: ReactNode;
  expanded?: boolean;
  isEdit?: boolean;
  onSummaryClick?: () => void;
}) {
  return (
    <FormSection
      expanded={expanded}
      summary={
        <FormSectionSummary
          optional
          withIcon={!isEdit}
          title="Custom Access Details"
          onClick={onSummaryClick}
          tooltip="Customize the access details message that will be displayed to end users when they access this integration."
        />
      }
      actions={expanded && actions}
    >
      <Stack spacing={2} justifyContent="center">
        <CustomAccessDetailsField integrationConfig={config} />
      </Stack>
    </FormSection>
  );
}
